export interface LectureCategory {
  id: number;
  name: string;
  route_name: string;
  level: number;
  parent_category_id: number | null;
  image_url: string | null;
  optimized_image_url: string | null;
}

export interface LectureCategoryListResponse {
  code: number;
  status: string;
  message: string;
  data: LectureCategory[];
}

// 강의 카테고리 목록 가져오기
export const fetchLectureCategories = async (): Promise<LectureCategoryListResponse> => {
  try {
    const { apiClient } = await import('.');
    const { data } = await apiClient.get<LectureCategoryListResponse>(
      '/api/lecture-categories/list'
    );
    return data;
  } catch (error) {
    /// console.error('강의 카테고리 목록 가져오기 실패:', error);
    throw error;
  }
};
